module.exports = __webpack_public_path__ + "img/man.d6724ec0.png";